import { largeDecimalFormat } from 'common/formats/formats';
import { ParserParams } from 'common/types/scalarSpreadsheet';
import commonInvestmentParser from '../../commonInvestmentParser';

const firmInvestmentParser = (params: ParserParams<any>) =>
  commonInvestmentParser({
    ...params,
    options: {
      useValueDirectly: false,
      shareCountFormat: largeDecimalFormat,
      lastRowFirstColumnFormat: largeDecimalFormat,
      useTotalValueCustomKey: true,
    },
  });

export default firmInvestmentParser;
